import { createSelector } from 'reselect';

import { createUiSelector } from '../ui/helpers';

const domain = ({ documentFields }) => documentFields;

export const getFields = createSelector(domain, documentFields => documentFields.get('fields'));

export const getFetchFieldsUI = createUiSelector(['documentFields', 'fetchFields'], true);
